import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useProdutoService() {
    const { authenticatedFetch, authenticatedFormFetch } = useApi();

    const criarProduto = async (formData) => {
        const response = await authenticatedFormFetch(URLS.CREATE_PRODUTO, formData);
        return response.json();
    };

    const atualizarProduto = async (formData) => {
        const response = await authenticatedFormFetch(URLS.UPDATE_PRODUTO, formData);
        return response.json();
    };

    const deletarProduto = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_PRODUTO, {
        method: 'POST',
        body: JSON.stringify({ id }),
        });
        return response.json();
    };

    const listarProdutos = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_PRODUTO);
        return response.json();
    };

    const obterProdutoPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_PRODUTO, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });
        return response.json();
    };

    return {
        criarProduto,
        atualizarProduto,
        deletarProduto,
        listarProdutos,
        obterProdutoPorId,
    };
}